interface IOptions {
  errorTimeout?: number
  errorEvents?: string[]
}

const defaultErrorTimeout = 5000
const defaultErrorEvents = ['error']

let errorTimeoutTimer: any = null

export default function(src: string,  options: IOptions = {}): Promise<HTMLImageElement> {
  const { errorTimeout } = options
  const curErrorTimeout = errorTimeout || defaultErrorTimeout
  // console.log('curErrorTimeout', curErrorTimeout, src)
  const image = new Image()

  clearAll(image, options)
  return new Promise((resolve, reject) => {
    image.onload = () => {
      // console.log('onloadImage', image)
      resolve(image)
    }
    image.src = src
    // console.log('image.src', image.src)

    addErrorEvents(image, options, event => {
      // console.log('addErrorEvents', image, options)
      reject('Load Image Error: ' + event)
    })

    errorTimeoutTimer = setTimeout(() => {
      // console.log('errorTimeoutTimer', image, options)
      reject(new Error('Load Image Timeout'))
    }, curErrorTimeout)
  })
}

function clearAll(image: HTMLImageElement, options: IOptions) {
  image.onload = null
  clearErrorEvents(image, options)
  clearTimeout(errorTimeoutTimer)
  errorTimeoutTimer = null
}

function addErrorEvents(image: HTMLImageElement, options: IOptions, callback: (event: string) => void) {
  const { errorEvents } = options
  const events = errorEvents || defaultErrorEvents

  events.forEach(_ => {
    (image as any)['on' + _] = () => {
      callback(_)
    }
  })
}

function clearErrorEvents(image: HTMLImageElement, options: IOptions) {
  const { errorEvents } = options
  const events = errorEvents ? [ ...defaultErrorEvents, ...errorEvents ] : [ ...defaultErrorEvents ]
  events.forEach(_ => {
    (image as any)['on' + _] = null
  })
}
